module.exports = __webpack_public_path__ + "static/popup_SP@2x-min-a8515325552c5454a91cc737636b112f.webp";